import { Button, dialog } from "nq-component";
import BaseListPresenter from "../../../../base/BaseListPresenter";
import { createNotification } from "../../../../createNotification";
import Queue from "nq";

class SpecialAwardPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase,
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }

  init() {
    this.limit = 10;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      this.view.setObjects(objects);
      this.view.setCurrent(this.current);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  setCurrentPage(page) {
    this.current = page;
    this.documents = [];
    this.view.setCurrent(page);
    this.view.setObjects([]);
    this.findObjects();
  }

  async Save(collection, data) {
    try {
      await this.upsertUseCase.execute(collection, data);
    } catch (e) {
      console.error(e);
    }
  }

  async handleCloseNomi(object) {
    if (object.isEnable === "enable") {
      const disableBtn = { ...object, isEnable: "unable" };
      try {
        await this.Save(this.view.getCollectionName(), disableBtn);
        const { isEnable, ...object } = disableBtn;
        await this.Save("open_for_nomination", object);
        await this.Save("nomination_list", object);

        //  CREATE NOTIFICATION
        const NOTIFICATION_MESSAGE = "A new nomination has open";
        const NOTIFICATION_RECEIVER = ["role:user"];
        const NOTIFICATION_REDIRECT = "nomination";

        createNotification(
          NOTIFICATION_MESSAGE,
          NOTIFICATION_RECEIVER,
          NOTIFICATION_REDIRECT,
        );
        // this.showSuccess("SUCCESS");
      } catch (error) {
        this.view.showError(error.message);
      }
      this.view.refetchData();
    } else {
      const enableBtn = { ...object, isEnable: "enable" };
      try {
        dialog.fire({
          html: (
            <div className="p-2">
              <div className="row">
                <h4>Confirmation</h4>
                <hr />
                <p style={{ fontSize: "13px", padding: "1rem" }}>
                  Are you sure you want to <b>Close Nomination?</b>
                </p>
                <hr />
              </div>

              <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
                <Button
                  className="btn btn-light fs-sm"
                  onClick={() => dialog.close()}
                >
                  Cancel
                </Button>
                <Button
                  className="btn btn-primary"
                  onClick={() => this.view.handleOpenNomination(enableBtn)}
                >
                  Confirm
                </Button>
              </div>
            </div>
          ),
          footer: false,
        });
      } catch (error) {
        this.view.showError(error.message);
      }
    }
  }

  async handleOpenNomination(enableBtn) {
    await this.Save(this.view.getCollectionName(), enableBtn);

    const query = {
      where: {
        id: enableBtn.id,
      },
    };
    const deleteApprove = await this.findObjectUseCase.execute(
      "approve_nomination",
      { where: { title: enableBtn.title } },
    );
    console.log("APPROVE: ", deleteApprove);
    for (const approve of deleteApprove) {
      // await this.deleteObjectUseCase.execute("approve_nomination", approve.id);
      await new Queue.Document().delete("approve_nomination", approve.id);
    }
    const nominationReq = await this.findObjectUseCase.execute(
      "nomination_request",
      query,
    );
    for (const request of nominationReq) {
      // await this.deleteObjectUseCase.execute("nomination_request", request.id);
      await new Queue.Document().delete("nomination_request", request.id);
    }

    const openForNomi = await this.findObjectUseCase.execute(
      "open_for_nomination",
      query,
    );
    for (const openNomi of openForNomi) {
      // await this.deleteObjectUseCase.execute(
      //   "open_for_nomination",
      //   openNomi.id
      // );
      await new Queue.Document().delete("open_for_nomination", openNomi.id);
    }

    // const specialAwards = await findObjectUseCase().execute("special_award", {
    //   where: { title: object.title },
    // });

    // const { isEnable, ...specialAward } = specialAwards[0];
    // await upsertUseCase().execute("special_award", {
    //   isEnable: "enable",
    //   ...specialAward,
    // });

    this.view.refetchData();
    dialog.close();
  }
}
export default SpecialAwardPresenter;
